import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { ControlPoint, PrintOutlined } from "@material-ui/icons";
import FilterListIcon from "@material-ui/icons/FilterList";
import {
  KTV_HAS_ASSIGN_TREATMENT,
  SHOW_UPDATE_TOUR_AND_IMAGE_TREATMENT,
} from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import {
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleTechician,
  transformDate,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import TreatmentUpdateMultiplePopup from "app/TreatmentManagement/TreatmentUpdateImageAndTour/Popup/TreatmentUpdateMultiplePopup";
import { Form, Formik } from "formik";
import history from "history.js";
import { observer } from "mobx-react";
import moment from "moment";
import { memo, useEffect, useState } from "react";
import * as Yup from "yup";
import ListTreatment from "./ListTreatment";
import AllocationServiceInfoPopup from "./Popup/AllocationServiceInfoPopup";
import TreatmentPreviewPrintPopup from "./Popup/TreatmentPreviewPrintPopup";
import TreatmentResultPopup from "./Popup/TreatmentResultPopup";
import SearchTreatment from "./SearchTreatment";
import PopupHistoryTreament from "./Popup/PopupHistoryTreament";

const TreatmentIndex = () => {
  const {
    searchObject,
    handleSetSearchObject,
    resetStore,
    pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate,
    openConfirmDeleteNewServiceRequestItem,
    handleConfirmDeleteNewServiceRequestItem,
    handleClose,
    openTreatmentResultPopup,
    initDataTreatmentResultPopup,
    handleCloseTreatmentResultPopup,
    allocationServiceInfo,
    listSelectedItem,
    handleOpenPrintTreatmentPopup,
    openPrintTreatmentPopup,
    handleClosePrintTreatmentPopup,
    pageHistoryServiceRequestItem,
    openPopupHistory,
    handleCloseHistoryPopup
  } = useStore().patientManagementStore.serviceRequestItemStore;

  const {
    handleOpenUncompletedServicePopup,
    resetStore: resetUncompletedRegisterServiceStore,
  } = useStore().patientManagementStore.uncompletedRegisterServiceStore;

  const {
    handleOpenPopupSelectedTreatment,
    openPopupSelectedTreatment,
    handleClosePopupSelectedTreatment,
    handleSubmitUpdateMultipleTreatment,
    searchTreatment,
    handleChangeFormSearchTreatment,
  } = useStore().treatmentManagementStore.treatmentUpdateImageAndTourStore;

  const urlParams = new URLSearchParams(window.location.search);
  const patientId = urlParams.get("patientId");
  const defaultDepartment = useDefaultDepartment();

  let [isOpenFillter, setOpenFillter] = useState(true);
  const { initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  useEffect(() => {
    resetUncompletedRegisterServiceStore();

    if (patientId) {
      handleFilter();
    }
    return resetStore;
  }, [patientId, defaultDepartment]);

  const validationSchema = Yup.object().shape({
    orderDateFrom: Yup.date()
      .transform(transformDate)
      .typeError("Thời gian chỉ định từ không đúng định dạng!")
      .test(
        "from-before-to",
        "Thời gian chỉ định từ không được lớn hơn Thời gian chỉ định đến!",
        function (from) {
          const { orderDateTo } = this.parent;
          if (
            from &&
            orderDateTo &&
            moment(from).isValid() &&
            moment(orderDateTo).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(orderDateTo));
          }
          return true;
        }
      )
      .nullable(),

    orderDateTo: Yup.date()
      .transform(transformDate)
      .typeError("Thời gian chỉ định đến không đúng định dạng!")
      .test(
        "to-after-from",
        "Thời gian chỉ định đến không được nhỏ hơn Thời gian chỉ định từ!",
        function (to) {
          const { orderDateFrom } = this.parent;
          if (
            orderDateFrom &&
            to &&
            moment(orderDateFrom).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(orderDateFrom));
          }
          return true;
        }
      )
      .nullable(),

    performDateFrom: Yup.date()
      .transform(transformDate)
      .typeError("Thời gian bắt đầu thực hiện không đúng định dạng!")
      .test(
        "from-before-to",
        "Thời gian bắt đầu thực hiện không được lớn hơn Thời gian kết thúc thực hiện!",
        function (from) {
          const { performDateTo } = this.parent;
          if (
            from &&
            performDateTo &&
            moment(from).isValid() &&
            moment(performDateTo).isValid()
          ) {
            return moment(from).isSameOrBefore(moment(performDateTo));
          }
          return true;
        }
      )
      .nullable(),

    performDateTo: Yup.date()
      .transform(transformDate)
      .typeError("Thời gian kết thúc thực hiện không đúng định dạng!")
      .test(
        "to-after-from",
        "Thời gian kết thúc thực hiện không được nhỏ hơn Thời gian bắt đầu thực hiện!",
        function (to) {
          const { performDateFrom } = this.parent;
          if (
            performDateFrom &&
            to &&
            moment(performDateFrom).isValid() &&
            moment(to).isValid()
          ) {
            return moment(to).isSameOrAfter(moment(performDateFrom));
          }
          return true;
        }
      )
      .nullable(),
  });

  async function handleFilter(values) {
    try {
      handleSetSearchObject({
        ...searchObject,
        ...values,
        patientId,
      });

      pagingServiceRequestItemByPatientServiceRegisterInfoGroupDate();
    } catch (error) {
      console.error(error);
    }
  }

  const { handleGetPatientOverviewByIdNotLoading } =
    useStore().patientManagementStore.patientGeneralStore;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  const isModuleTreatment = window.location.pathname.includes(
    "/treatment-management/treatment-patient-info-detail"
  );
  const isModulePatientManagement = window.location.pathname.includes(
    "/patient-management/patient-general"
  );



  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isAdmins = isAdmin();
  const isRoleBranchManagers = isRoleBranchManager();
  const isDoctors = isDoctor();
  const isCashier = isRoleCashier();
  const isAccountant = isRoleHisAccountant();
  const canEditTreatment =
    isAdmins || isRoleCt || isDoctors || isRoleBranchManagers;
  const canAssign = isModulePatientManagement && (isAdmins || isRoleBranchManagers || isCashier || isAccountant);
  return (
    <Grid container spacing={1}>
      <Grid item xs={6} sm={6}>
        <div
          className=" flex justify-between gap-2"
          style={{ fontSize: "16px" }}
        >
          <span
            className="cards-header flex items-center pointer"
            style={{ fontWeight: "bold", padding: "10px" }}
          >
            Điều trị
            <FilterListIcon
              style={{ marginRight: 8, cursor: "pointer" }}
              onClick={() => setOpenFillter(!isOpenFillter)}
            />
          </span>
        </div>
      </Grid>
      <Grid item xs={6} sm={6}>
        <div
          className="flex justify-end gap-2 mt-4"
          style={{ padding: "10px" }}
        >
          {listSelectedItem?.length > 0 && (
            <Tooltip arrow placement="top" title="In chỉ định">
              <CommonButton
                onClick={handleOpenPrintTreatmentPopup}
                style={{
                  backgroundColor: "#f16321",
                  color: "white",
                  marginRight: "4px",
                }}
              >
                <PrintOutlined />
                {!isMobile && " In tùy chọn"}
              </CommonButton>
            </Tooltip>
          )}
          {(canAssign || (isModuleTreatment && KTV_HAS_ASSIGN_TREATMENT)) && (
            <Tooltip arrow placement="top" title="Chỉ định thực hiện dịch vụ">
              <CommonButton
                className="btn-add"
                onClick={() => {
                  handleOpenUncompletedServicePopup();
                }}
              >
                <ControlPoint />
                <span className="ml-1">Chỉ định</span>
              </CommonButton>
            </Tooltip>
          )}

          {canEditTreatment &&
            isModuleTreatment &&
            SHOW_UPDATE_TOUR_AND_IMAGE_TREATMENT && (
              <Tooltip arrow placement="top" title="Cập nhật nhiều điều trị">
                <CommonButton
                  className="btn-add"
                  onClick={() => {
                    handleOpenPopupSelectedTreatment();
                  }}
                >
                  <ControlPoint />
                  {!isMobile && (
                    <span className="ml-1">Cập nhật nhiều điều trị</span>
                  )}
                </CommonButton>
              </Tooltip>
            )}
        </div>
      </Grid>

      <Grid item xs={12}>
        <Formik
          initialValues={{ ...searchObject }}
          validationSchema={validationSchema}
          onSubmit={handleFilter}
          enableReinitialize
        >
          <Form autoComplete="off" style={{ padding: "10px" }}>
            <SearchTreatment isOpenFillter={isOpenFillter} />

            {/* <ListTreatment /> */}
            <ListTreatment />
            {openConfirmDeleteNewServiceRequestItem && (
              <ConfirmPopup
                size="xs"
                open={openConfirmDeleteNewServiceRequestItem}
                onClose={() => handleClose()}
                text="Bạn có chắc chắn xóa chỉ định dịch vụ?"
                onConfirm={async () => {
                  await handleConfirmDeleteNewServiceRequestItem();
                  if (patientId) {
                    await handleGetPatientOverviewByIdNotLoading(patientId);
                  }
                }}
              />
            )}

            {openTreatmentResultPopup && (
              <TreatmentResultPopup
                open={openTreatmentResultPopup}
                initialValues={initDataTreatmentResultPopup}
                handleClose={handleCloseTreatmentResultPopup}
              />
            )}

            {allocationServiceInfo?.id && (
              <AllocationServiceInfoPopup
                handleRenewScreen={handleFilter}
                initialPatient={initialPatient}
              />
            )}
            {
              <TreatmentPreviewPrintPopup
                open={openPrintTreatmentPopup}
                handleClose={handleClosePrintTreatmentPopup}
                patient={initialPatient?.patientInfo}
                listSelectedItem={listSelectedItem}
              />
            }

            {openPopupSelectedTreatment && (
              <TreatmentUpdateMultiplePopup
                open={openPopupSelectedTreatment}
                handleClose={handleClosePopupSelectedTreatment}
                handleSubmit={handleSubmitUpdateMultipleTreatment}
                initialValues={searchTreatment}
                handleChangeFormSearchTreatment={
                  handleChangeFormSearchTreatment
                }
                handleAfterSubmit={() => {
                  history.push(
                    `/treatment-management/treatment-update-tour-and-image?patientId=${patientId}`
                  );
                }}
              />
            )}

            {openPopupHistory && (
              <PopupHistoryTreament
                open={openPopupHistory}
                handleClose={handleCloseHistoryPopup}
                data={pageHistoryServiceRequestItem}
              />
            )}
          </Form>
        </Formik>
      </Grid>
    </Grid>
  );
};

export default memo(observer(TreatmentIndex));
